<script lang="ts" setup>
import { definePageMeta } from '#imports'
import { useSlug } from '~/composables/news/use-slug'
definePageMeta({
  pageTransition: {
    mode: 'default'
  }
})

const { handleSlug, getCurrentComponent, slugType: SlugType } = useSlug()
const slugType = await handleSlug()
const currentComponent = await getCurrentComponent(slugType)

if (slugType === SlugType.NEWS_DETAIL) {
  useSeoMeta({ description: null, ogDescription: null, twitterDescription: null })
}
</script>

<template>
  <div>
    <component v-bind:is="currentComponent" />
  </div>
</template>
